import React, { useEffect, useRef } from "react";
import {
  FaBitcoin,
  FaEthereum,
  FaAmazon,
  FaAngular,
  FaDrupal,
  FaGithub,
  FaJava,
  FaLaravel,
  FaNodeJs,
  FaPython,
  FaReact,
  FaDatabase,
  FaWater,
  FaProjectDiagram,
} from "react-icons/fa";
import {
  SiBinance,
  SiCardano,
  SiHedera,
  SiNear,
  SiPolkadot,
  SiPolygon,
  SiSolana,
  SiStellar,
  SiFlutter,
  SiExpress,
  SiGo,
  SiMongodb,
  SiMysql,
  SiNextdotjs,
  SiNuxt,
  SiSolidity,
  SiSwift,
  SiThreedotjs,
  SiTypescript,
  SiWebrtc,
} from "react-icons/si";

function Testimonials() {
  const track1Ref = useRef(null);
  const track2Ref = useRef(null);

  const position1 = useRef(0);
  const position2 = useRef(0);

  const speed1 = useRef(1);
  const speed2 = useRef(-1);

  const targetSpeed1 = useRef(1);
  const targetSpeed2 = useRef(-1);

  useEffect(() => {
    let animationFrame;

    const animate = () => {
      // Smooth easing
      speed1.current += (targetSpeed1.current - speed1.current) * 0.05;
      speed2.current += (targetSpeed2.current - speed2.current) * 0.05;

      position1.current -= speed1.current;
      position2.current -= speed2.current;

      const track1 = track1Ref.current;
      const track2 = track2Ref.current;

      if (track1) {
        const width = track1.scrollWidth / 2;

        // LEFT MOVING ROW
        if (position1.current <= -width) {
          position1.current += width;
        }

        track1.style.transform = `translateX(${position1.current}px)`;
      }

      if (track2) {
        const width = track2.scrollWidth / 2;

        // RIGHT MOVING ROW
        if (position2.current >= 0) {
          position2.current -= width;
        }

        track2.style.transform = `translateX(${position2.current}px)`;
      }

      animationFrame = requestAnimationFrame(animate);
    };

    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  // Row 1 Hover
  const handleEnterRow1 = () => {
    targetSpeed1.current = 0.2;
  };

  const handleLeaveRow1 = () => {
    targetSpeed1.current = 1;
  };

  // Row 2 Hover
  const handleEnterRow2 = () => {
    targetSpeed2.current = -0.2;
  };

  const handleLeaveRow2 = () => {
    targetSpeed2.current = -3;
  };

  const iconStyle = { fontSize: "65px" }; // Standard size for all icons in carousel

  // Map out the icons sequence for Track 1
  const track1Icons = [
    { Icon: SiBinance, color: "#F3BA2F", name: "BSC" },
    { Icon: FaBitcoin, color: "#F7931A", name: "BTC" },
    { Icon: SiCardano, color: "#0033AD", name: "Cardano" },
    { Icon: FaEthereum, color: "#3C3C3D", name: "Ethereum" },
    { Icon: SiHedera, color: "#222222", name: "Hedera" },
    { Icon: SiNear, color: "#000000", name: "Near" },
    { Icon: SiPolkadot, color: "#E6007A", name: "Polkadot" },
    { Icon: SiPolygon, color: "#8247E5", name: "Polygon" },
    { Icon: SiSolana, color: "#14F195", name: "Solana" },
    { Icon: SiStellar, color: "#08B5E5", name: "Stellar" },
    { Icon: FaProjectDiagram, color: "#FF0606", name: "Tron" },
    { Icon: FaWater, color: "#0155FF", name: "Waves" },
  ];

  // Repeat for smooth scrolling
  const track1Sequence = [...track1Icons, ...track1Icons];

  // Map out the icons sequence for Track 2
  const track2Icons = [
    { Icon: FaAmazon, color: "#FF9900", name: "Amazon" },
    { Icon: FaAngular, color: "#DD0031", name: "Angular" },
    { Icon: FaDrupal, color: "#0678BE", name: "Drupal" },
    { Icon: SiExpress, color: "#000000", name: "Express" },
    { Icon: SiFlutter, color: "#02569B", name: "Flutter" },
    { Icon: FaGithub, color: "#181717", name: "GitHub" },
    { Icon: SiGo, color: "#00ADD8", name: "Go" },
    { Icon: FaJava, color: "#007396", name: "Java" },
    { Icon: FaLaravel, color: "#FF2D20", name: "Laravel" },
    { Icon: SiMongodb, color: "#47A248", name: "MongoDB" },
    { Icon: SiMysql, color: "#4479A1", name: "MySQL" },
    { Icon: SiNextdotjs, color: "#000000", name: "Next.js" },
    { Icon: FaNodeJs, color: "#339933", name: "Node.js" },
    { Icon: SiNuxt, color: "#00C58E", name: "Nuxt.js" },
    { Icon: FaDatabase, color: "#F80000", name: "Oracle" }, // Oracle approx red DB
    { Icon: FaPython, color: "#3776AB", name: "Python" },
    { Icon: FaReact, color: "#61DAFB", name: "React" },
    { Icon: SiSolidity, color: "#363636", name: "Solidity" },
    { Icon: SiSwift, color: "#F05138", name: "Swift" },
    { Icon: SiThreedotjs, color: "#000000", name: "Three.js" },
    { Icon: SiTypescript, color: "#3178C6", name: "TypeScript" },
    { Icon: SiWebrtc, color: "#333333", name: "WebRTC" },
  ];

  const track2Sequence = [...track2Icons, ...track2Icons];

  return (
    <div
      className="testimonial-style-two-area default-padding bg-gray bg-cover"
      style={{
        background:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-16.jpg)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2 className="sub-title">STANDING ON THE EDGE OF INNOVATION</h2>
              <h2 className="title split-text-right split-text-in-right split-lines">
                Technologies we work with
              </h2>
              <p>
                We have worked on several leading blockchain networks including
                Ethereum, Solana, Polygon, BNB Chain, Tron, Arbitrum & many
                more.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* ROW 1 */}
      <div
        onMouseEnter={handleEnterRow1}
        onMouseLeave={handleLeaveRow1}
        style={{ overflow: "hidden" }}
      >
        <ul
          ref={track1Ref}
          style={{
            display: "flex",
            gap: "20px",
            width: "max-content",
          }}
        >
          {track1Sequence.map((item, index) => (
            <div
              className="img-box-one"
              style={{ marginLeft: index === 0 ? "0.5%" : "0" }}
              key={`track1-${index}`}
            >
              <div
                className="justify-content-center"
                style={{ display: "flex", alignItems: "center", height: "100%" }}
                title={item.name}
              >
                <item.Icon style={{ ...iconStyle, color: item.color }} />
              </div>
            </div>
          ))}
        </ul>
      </div>

      {/* ROW 2 */}
      <div
        onMouseEnter={handleEnterRow2}
        onMouseLeave={handleLeaveRow2}
      >
        <ul
          ref={track2Ref}
          style={{
            display: "flex",
            gap: "20px",
            width: "max-content",
          }}
        >
          {track2Sequence.map((item, index) => (
            <div
              className="img-box-one"
              style={{ marginLeft: index === 0 ? "0.5%" : "0" }}
              key={`track2-${index}`}
            >
              <div
                className="justify-content-center"
                style={{ display: "flex", alignItems: "center", height: "100%" }}
                title={item.name}
              >
                <item.Icon style={{ ...iconStyle, color: item.color }} />
              </div>
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Testimonials;
